import React from 'react';

import { generatePath } from 'react-router-dom';
import { convertTo62, isUUID } from 'uuid-encoding';

import {
  ChargePartial,
  ExternalEntityType,
} from 'lane-shared/domains/billingPayments/types';
import { routes } from 'lane-shared/config';

import { H5, M } from 'components/typography';
import { ItemsTable } from '../../ItemsTable';

import styles from './styles.scss';

function buildSrHref(channelSlug: string, externalEntityId: string): string {
  const srId = isUUID(externalEntityId)
    ? convertTo62(externalEntityId)
    : externalEntityId;

  return `${generatePath(routes.channelAdminWorkOrdersServiceRequestDetails, {
    id: channelSlug,
    serviceRequestId: srId,
  })}?tab=billing`;
}

export function ChargeCard({
  channelId,
  channelSlug,
  charge,
}: {
  channelId: string;
  channelSlug: string | undefined;
  charge: ChargePartial;
}) {
  const srHref =
    channelSlug &&
    charge.externalEntityType ===
      ExternalEntityType.EXTERNAL_ENTITY_TYPE_WORKORDER &&
    charge.externalEntityId
      ? buildSrHref(channelSlug, charge.externalEntityId)
      : null;

  const isVoided = charge.status === 'VOIDED';

  const chargeName = srHref ? (
    <a href={srHref} target="_blank" rel="noreferrer">
      {charge.name}
    </a>
  ) : (
    charge.name
  );

  return (
    <div className={styles.cardWrapper}>
      <div className={styles.ChargeHeader}>
        <H5>{isVoided ? <s>{chargeName}</s> : chargeName}</H5>
        <M>{isVoided ? <s>{charge.description}</s> : charge.description}</M>
      </div>

      {charge.items.length > 0 && (
        <ItemsTable channelId={channelId} charge={charge} />
      )}
    </div>
  );
}
